import { configureStore, combineReducers } from "@reduxjs/toolkit";
import SurveyPageData from "./SurveyPageData";
import HandleLogin from "./HandleLogin";
import surveyData from "./UpdateSurveyData";
import ImportSlices from "./ImportSlices";

const rootReducer = combineReducers({
  SurveyPageData: SurveyPageData,
  HandleLogin: HandleLogin,
  surveyData: surveyData,
  ImportSlices: ImportSlices,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
